export default __webpack_public_path__ + "static/media/approvazione-docenti-nc.7e47f171.svg";